import { ActivityEntityName, Label, LabelType, MetadataEntityFieldEditorType, MetadataEntityFieldType, SurfaceSchema, SurfaceType } from '@jms/model';
import { defineSurfaceSchema } from '@workbuddy/ui/v2/surface.engine';

export type FlagCreateFormModel = {
  category?: Label | null;
  message?: string;
};

/** Dialog-scale Form schema for creating a Flag on a host entity. */
export function buildFlagCreateFormSchema(): SurfaceSchema {

  return defineSurfaceSchema(ActivityEntityName.Flag, SurfaceType.Form)
    .model<FlagCreateFormModel>()
    .body(body => body
      .section('details', section => section
        .title('Flag')
        .columns(1)
        .field({
          bind: 'category',
          required: true,
          metadata: { displayName: 'Category', type: MetadataEntityFieldType.Tag, entity: ActivityEntityName.Tag },
          editorInputs: { entityOptions: { type: LabelType.FlagCategory } },
        })
        .field({
          bind: 'message',
          required: true,
          metadata: { displayName: 'Message', type: MetadataEntityFieldType.String, editor: MetadataEntityFieldEditorType.TextArea },
        })))
    .build();
}
